import {
  formatError
} from "./chunk-YJZLA5P4.mjs";

// src/error/ErrorFormat.tsx
import React from "react";
var ErrorFormat = ({ error }) => error ? /* @__PURE__ */ React.createElement("ul", null, formatError(error).map((message, index) => /* @__PURE__ */ React.createElement("li", { key: index }, message))) : null;

export {
  ErrorFormat
};
